import ValidatorResult from "../classes/validator.results";
export default class TypeValidationRule {
    name = 'type';
    validate(validation, rules, value, object, manager) {
        //Vars
        let tTypeName = rules?.props?.type ?? rules.props;
        let tMessage = utils.format('This is not a valid {0}', rules.props);
        let tValue = false;
        //Check
        if (utils.isNullOrEmpty(value)) {
            return new ValidatorResult(true);
        }
        //Run
        switch (tTypeName.toLowerCase()) {
            case 'boolean':
                tValue = typeof value === 'boolean';
                break;
            case 'number':
                tValue = typeof value === 'number';
                break;
            case 'integer':
                tValue = typeof value === 'number' && parseInt(value.toString(), 10) === value;
                break;
            case 'float':
                tValue = typeof value === 'number' && parseInt(value.toString(), 10) !== value;
                break;
            case 'string':
                tValue = typeof value === 'string';
                break;
            case '':
                tValue = typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
                break;
            case 'url':
                tValue = (new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i')).test(value);
                break;
            case 'email':
                tValue = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
                tMessage = appHost.localizer?.t('system.Validation.EmailAddress', [validation.displayName]) ?? '';
                break;
        }
        return new ValidatorResult(tValue, tValue ? "" : tMessage);
    }
}
